import Collapse from './Collapse';
export default Collapse;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.3.3@antd/es/collapse/index.js
// module id = 534
// module chunks = 0